<template>
    <div>
        <el-form-item prop="name" :label="field.name + '：'" label-width="110px">
            <el-input clearable type="number" v-model="config[field.key]" :placeholder="field.memo"></el-input>
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

    /**
     * Created by huangdonglin on 2018/1/3.
     */
    export default {
        name: 'tms-type-number',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            config: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        data() {
            return {}
        },

        components: {},

        mounted() {

        },

        methods: {}
    }

</script>
